"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.DeviceLocationStack = exports.DeviceLocationStackQuery = exports.DeviceLocationFocus = exports.DeviceLocationFocusQuery = exports.DeviceLocationIndexStatus = exports.DeviceLocationIndexState = exports.DeviceMarkers = exports.DeviceLocationsQuery = exports.BoundsTuple = exports.extraToWire = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const geography_1 = require("../../../../geography");
const Device = __importStar(require("../../../device"));
const Dashboard = __importStar(require("../../dashboard/overview"));
const Protocol = __importStar(require("../protocol"));
const authorization_1 = require("./authorization");
const device_filters_1 = require("./device-filters");
const Error = __importStar(require("./error"));
const Tenant = __importStar(require("./tenant"));
const tracing_1 = require("./tracing");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Dashboard';
const getOverviewPage = platform_1.HttpApiEndpoint.get('getOverviewPage') `/overview`
    .middleware(Tenant.Middleware)
    .setUrlParams(Dashboard.OverviewPageQuery)
    .addSuccess(Protocol.responseBodySuccess(Dashboard.OverviewPage))
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Fleet Overview')
    .annotate(platform_1.OpenApi.Description, 'Fetch cached fleet overview counters');
const ConnectionStateFromNumber = effect_1.Schema.transformLiterals([0, 'disconnected'], [1, 'connected']);
// Adding a 'none' value to indicate that this device has no alarms
const SeverityFromNumber = effect_1.Schema.transformLiterals([0, 'non-critical'], [1, 'critical'], [2, 'none']);
const ConsumableConditionFromNumber = effect_1.Schema.transformLiterals([0, 'critical'], [1, 'warning'], [2, 'ok']);
const wireTable = ({ members }) => new Map(members.map(({ from, to }) => [to.literals[0], from.literals[0]]));
const wireByInclude = {
    ConnectionState: wireTable(ConnectionStateFromNumber),
    Alarms: wireTable(SeverityFromNumber),
    FilterStatus: wireTable(ConsumableConditionFromNumber),
    Co2Status: wireTable(ConsumableConditionFromNumber),
    EnhancementsStatus: wireTable(ConsumableConditionFromNumber),
};
const extraToWire = (include, extra) => {
    const wire = wireByInclude[include].get(extra);
    if (wire === undefined)
        throw new globalThis.Error(`'${extra}' is not a ${include} marker value`);
    return wire;
};
exports.extraToWire = extraToWire;
const DeviceMarker = (extraField) => effect_1.Schema.Tuple(geography_1.Latitude, geography_1.Longitude, extraField);
// A null expansion zoom marks a stack of devices at one exact position.
const ClusterTuple = (extraField) => effect_1.Schema.Tuple(geography_1.Latitude, geography_1.Longitude, effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(2)), extraField, effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.between(1, Device.Marker.Grid.UNCLUSTERED_ZOOM))));
exports.BoundsTuple = effect_1.Schema.Tuple(geography_1.Longitude, geography_1.Latitude, geography_1.Longitude, geography_1.Latitude).annotations({
    identifier: `${exports.NAMESPACE}.BoundsTuple`,
    description: '`[west, south, east, north]` in degrees',
});
// With `zoom`, `devices` holds only the devices that stand alone; `bounds` and `total` cover all.
const makeMarkersFor = (tag, extraField) => effect_1.Schema.Struct({
    includes: effect_1.Schema.tag(tag),
    devices: effect_1.Schema.Record({
        key: Device.Class.Common.Id,
        value: DeviceMarker(extraField),
    }),
    clusters: effect_1.Schema.optionalWith(effect_1.Schema.Array(ClusterTuple(extraField)), { exact: true }),
    bounds: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(exports.BoundsTuple), { exact: true }),
    total: effect_1.Schema.optionalWith(effect_1.Schema.Int, { exact: true }),
    truncated: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
});
const Zoom = effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(0, Device.Marker.Grid.MAX_ZOOM));
const Bbox = effect_1.Schema.String.pipe(effect_1.Schema.filter(s => effect_1.Option.isSome(Device.Marker.Grid.parseBbox(s)), {
    message: () => 'bbox must be west,south,east,north in degrees',
})).annotations({
    arbitrary: () => FC => FC.tuple(FC.double({ min: -180, max: 180, noNaN: true }), FC.double({ min: -90, max: 90, noNaN: true }), FC.double({ min: -180, max: 180, noNaN: true }), FC.double({ min: -90, max: 90, noNaN: true })).map(([west, a, east, b]) => [west, Math.min(a, b), east, Math.max(a, b)].join(',')),
});
exports.DeviceLocationsQuery = effect_1.Schema.Struct({
    ...device_filters_1.CommonDeviceFilterFields,
    zoom: effect_1.Schema.optionalWith(Zoom, { exact: true }),
    bbox: effect_1.Schema.optionalWith(Bbox, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationsQuery`,
    description: 'Query parameters for fetching device locations',
});
exports.DeviceMarkers = effect_1.Schema.Union(makeMarkersFor('ConnectionState', ConnectionStateFromNumber), makeMarkersFor('Alarms', SeverityFromNumber), makeMarkersFor('FilterStatus', ConsumableConditionFromNumber), makeMarkersFor('Co2Status', ConsumableConditionFromNumber), makeMarkersFor('EnhancementsStatus', ConsumableConditionFromNumber)).annotations({
    identifier: `${exports.NAMESPACE}.DeviceMarkers`,
    description: 'Device markers with location and extra field data',
});
const getDeviceLocations = platform_1.HttpApiEndpoint.get('getDeviceLocations') `/device-locations`
    .middleware(Tenant.Middleware)
    .setUrlParams(exports.DeviceLocationsQuery)
    .addSuccess(Protocol.responseBodySuccess(exports.DeviceMarkers), {
    status: 200,
})
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.ServiceUnavailableErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Device Locations')
    .annotate(platform_1.OpenApi.Description, 'Get a list of devices with their location data, filtered by connection state, model, alarm types, alarm severities, and consumable level. With `zoom`, nearby devices are clustered.');
exports.DeviceLocationIndexState = effect_1.Schema.Literal('off', 'loading', 'ready').annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationIndexState`,
    description: '`ready`: the index answers `zoom`, focus and stack requests; `loading`: it has not finished its first load; `off`: the reader is off, or the projection has never caught up, is stale or is lagging',
});
exports.DeviceLocationIndexStatus = effect_1.Schema.Struct({
    index: exports.DeviceLocationIndexState,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationIndexStatus`,
    description: 'State of the device map index on the replica that answers',
});
// No tenant middleware: the status carries no tenant data.
const getDeviceLocationIndexStatus = platform_1.HttpApiEndpoint.get('getDeviceLocationIndexStatus') `/device-locations/status`
    .addSuccess(Protocol.responseBodySuccess(exports.DeviceLocationIndexStatus))
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Device Location Index Status')
    .annotate(platform_1.OpenApi.Description, 'Whether the device map index of the replica that answers can serve `zoom`, focus and stack requests. Answered at once and never with a 503; a later request can still get one from another replica.');
exports.DeviceLocationFocusQuery = effect_1.Schema.Struct({
    ...device_filters_1.CommonDeviceFilterFields,
    deviceId: Device.Class.Common.Id,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationFocusQuery`,
    description: 'Query parameters for locating one device on the device map',
});
exports.DeviceLocationFocus = effect_1.Schema.Struct({
    /** Also null when the index is not `ready` and the location is unknown */
    location: effect_1.Schema.NullOr(effect_1.Schema.Tuple(geography_1.Latitude, geography_1.Longitude)),
    zoom: effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.between(0, Device.Marker.Grid.UNCLUSTERED_ZOOM))),
    stacked: effect_1.Schema.Boolean,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationFocus`,
    description: 'Where a device is on the device map and how far to zoom to single it out',
});
const getDeviceLocationFocus = platform_1.HttpApiEndpoint.get('getDeviceLocationFocus') `/device-locations/focus`
    .middleware(Tenant.Middleware)
    .setUrlParams(exports.DeviceLocationFocusQuery)
    .addSuccess(Protocol.responseBodySuccess(exports.DeviceLocationFocus))
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Device Location Focus')
    .annotate(platform_1.OpenApi.Description, 'Get the location of one device on the device map, and the zoom at which it stands alone, under the same filters as the map.');
exports.DeviceLocationStackQuery = effect_1.Schema.Struct({
    ...device_filters_1.CommonDeviceFilterFields,
    lat: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.between(-90, 90)),
    lon: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.between(-180, 180)),
    offset: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.nonNegative()), {
        exact: true,
        default: () => 0,
    }),
    limit: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(1, 200)), {
        exact: true,
        default: () => 50,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationStackQuery`,
    description: 'Query parameters for listing the devices at one exact position',
});
const makeStackFor = (tag, extraField) => effect_1.Schema.Struct({
    includes: effect_1.Schema.tag(tag),
    total: effect_1.Schema.Int,
    items: effect_1.Schema.Array(effect_1.Schema.Tuple(Device.Class.Common.Id, extraField)),
});
exports.DeviceLocationStack = effect_1.Schema.Union(makeStackFor('ConnectionState', ConnectionStateFromNumber), makeStackFor('Alarms', SeverityFromNumber), makeStackFor('FilterStatus', ConsumableConditionFromNumber), makeStackFor('Co2Status', ConsumableConditionFromNumber), makeStackFor('EnhancementsStatus', ConsumableConditionFromNumber)).annotations({
    identifier: `${exports.NAMESPACE}.DeviceLocationStack`,
    description: 'One page of the devices at one exact position on the device map',
});
const getDeviceLocationStack = platform_1.HttpApiEndpoint.get('getDeviceLocationStack') `/device-locations/stack`
    .middleware(Tenant.Middleware)
    .setUrlParams(exports.DeviceLocationStackQuery)
    .addSuccess(Protocol.responseBodySuccess(exports.DeviceLocationStack))
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.ServiceUnavailableErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Device Location Stack')
    .annotate(platform_1.OpenApi.Description, 'List the matching devices that share one exact position on the device map, a page at a time.');
exports.Spec = platform_1.HttpApiGroup.make('dashboard')
    .middleware(authorization_1.UserAuthorization)
    .middleware(tracing_1.Tracing)
    .add(getOverviewPage)
    .add(getDeviceLocations)
    .add(getDeviceLocationIndexStatus)
    .add(getDeviceLocationFocus)
    .add(getDeviceLocationStack)
    .prefix('/dashboard')
    .annotate(platform_1.OpenApi.Title, 'Dashboard')
    .annotate(platform_1.OpenApi.Description, 'Dashboard endpoints');
//# sourceMappingURL=dashboard.js.map